import { BaseNode } from "./base-node";
import type { CachedImageSource } from "./image-node";

export type BackgroundImageNodeParams = {
	url: string;
};

export interface ResolvedBackgroundImageNodeState {
	source: CachedImageSource["source"];
	width: number;
	height: number;
}

/**
 * A static, full-canvas-covering background image — project-level (one per TBackground, not a
 * movable/deletable timeline clip), sibling to ColorNode/BlurBackgroundNode. Unlike
 * BlurBackgroundNode, there's no per-frame clip timing to track (a background image is present
 * identically at every frame, like a color background), so this carries none of
 * BlurBackgroundNode's timeOffset/duration/trimStart/retime fields — just a URL, resolved once
 * via image-node.ts's existing loadImageSource (see resolve.ts's resolveBackgroundImageNode).
 */
export class BackgroundImageNode extends BaseNode<
	BackgroundImageNodeParams,
	ResolvedBackgroundImageNodeState
> {}
